<template>

    <v-dialog max-width="500" v-model="dialog">
        <v-card>
            <v-card-title>
                <span class="headline">Map Save Action</span>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" md="6" sm="6">
                        <v-text-field label="Key" v-model.trim="model.key" hide-details/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" md="6" sm="6">
                        <v-select
                            label="Select"
                            item-text="text"
                            item-value="value"
                            :items="list"
                            v-model.number="model.action"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-expansion-panels>
                    <mapkind-panel :items.sync="model.maps" title="Maps"/>
                </v-expansion-panels>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="onCancel" color="blue darken-1" text>
                    Cancel
                </v-btn>
                <v-btn @click="onPressSave" color="blue darken-1" text>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {MapSaveAction} from "@/modules/mutils/models/MapSaveAction";
import mapkindPanel from "./mapkind-panel.vue";
import {MapKindModel} from "@/modules/redactor/models/map/MapKindModel";

export default {
    name: "utils-map-save-action-pop-edit",
    props: {},
    components: {mapkindPanel},
    data: () => ({
        loading: {},
        dialog: false,
        onComplete:null,
        model: {},
        ref: {},
    }),
    computed: {
        list(){
            return Array.from(MapSaveAction.ACTIONS, ([key, value]) => ({ text: value, value: key }));
        }
    },
    
    methods: {
        show(model, onComplete) {
            this.model = Object.assign(new MapSaveAction(), model);
            this.dialog = true;
            this.onComplete = onComplete;
            if(model){
                this.ref = model;
            }
        },
        hide() {
            this.dialog = false;
        },
        onCancel() {
            this.hide();
        },
        onClose() {
            this.hide();
        },
        onPressSave() {
            if (this.model == null || this.model == undefined){
                return;
            }

            console.log(this.model);

            if(!this.model.key || this.model.key === "" || 
                !this.model.action || this.model.action === 0){
                this.$notify({title: 'Error', text: "invalid action", type: "error"});
                return;
            }

            if(!this.model.maps || this.model.maps.length === 0){
                this.$notify({title: 'Error', text: "invalid action", type: "error"});
                return;
            }
            
            console.log(this.model.maps);

            for(const id in this.model.maps){
                const map = this.model.maps[id];
                if(MapKindModel.isNone(map) || map.key === "map_merge" || map.key === "map_global"){
                    this.$notify({title: 'Error', text: "invalid action", type: "error"});
                    return;
                }
            }

            this.ref = Object.assign(this.ref, this.model);

            this.dialog = false;
            this.onComplete(this.ref);
        }
    },
}
</script>

<style scoped>

</style>